import { APP_INITIALIZER, ErrorHandler, Injectable, NgModule, Inject, Injector } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { HttpModule } from "@angular/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ToastModule, ToastOptions } from "ng2-toastr";
import { ModalModule } from "ngx-bootstrap/modal";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { appRoutes } from "./app.routes";
import { AppComponent } from "./app.component";
import { LayoutComponent } from "./components/layout/layout.component";
import { ConfigService } from "./services/configService";
import { CookieService } from "ng2-cookies";
import { LoginComponent } from "./components/auth/login/login.component";
import { UserService } from "./services/userService";
import { StorageManager } from "./common/managers/storageManager";
import { HomeComponent } from "./components/sip/home/home.component";
import { AuthGuard } from "./common/guards/authGuard";
import { FirstKeyPipe } from "./common/pipes/firstKeyPipe";
import { ErrorsSummaryComponent } from "./components/common/errorsSummary/errorsSummary.component";
import { RegisterComponent } from "./components/auth/register/register.component";
import { EqualValidatorDirective } from "./common/directives/validators/equalValidator";
import { OnFocusDirective } from "./common/directives/onFocus";
import { ForgotPasswordComponent } from "./components/auth/forgotPassword/forgotPassword.component";
import { ResetPasswordComponent } from "./components/auth/resetPassword/resetPassword.component";
import { FormInputComponent } from "./components/common/formInput/formInput.component";
import { AuthLayoutComponent } from "./components/auth/authLayout/authLayout.component";
import { CheckboxComponent } from "./components/common/checkbox/checkbox.component";
import { SideMenuComponent } from "./components/sidebar/sideMenu/sideMenu.component";
import { SideBarComponent } from "./components/sidebar/sideBar/sideBar.component";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { AppService } from "./services/appService";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { SipService } from "./services/sipService";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TrimValueAccessor } from "./common/directives/trimValueAccessor";
import { CheckboxRequiredValidatorDirective } from "./common/directives/validators/checkboxRequiredValidator";
import { FormSelectComponent } from "./components/common/formSelect/formSelect.component";
import { RadioComponent } from "./components/common/radio/radio.component";
import { NgTranscludeDirective } from "./common/directives/ngTransclude.directive";
import { AppGuard } from "./common/guards/appGuard";
import { RipplesDirective } from "./common/directives/ripples.directive";
import { GoogleLoginComponent } from "./components/auth/googleLogin/googleLogin.component";
import { CurrencyDashBoardComponent } from "./components/currencyExchange/currencyDashBoard.component";
import { CurrencyService } from "./services/currencyService";
import { CurrencyResolver } from "./components/currencyExchange/currency.resolver";
import { CurrencyChartComponent } from "./components/currencyExchange/currencyChart/currencyChart.component";
import { CurrencyTableComponent } from "./components/currencyExchange/currencyTable/currencyTable.component";
import { ChartsModule } from "ng2-charts";
import { GoogleService } from "./services/googleService";
import { LocationManagementComponent } from "./components/Managment/locationManagement/locationManagement.component";
import { LocationManagementResolver } from "./components/Managment/locationManagement/locationManagment.resolver";
import { LocationService } from "./services/locationService";
import { LocationManagementSearchComponent } from "./components/Managment/locationManagement/locationManagementSearch/locationManagementSearch.component";
import { LocationManagementTableComponent } from "./components/Managment/locationManagement/locationManagementTable/locationManagementTable.component";
import { InlineSelectComponent } from "./components/common/inlineSelect/inlineSelect.component";
import { GooglePlaceModule } from "../node_modules/ng2-google-place-autocomplete/src/app/ng2-google-place.module";
import { InlineLocationComponent } from "./components/Managment/locationManagement/locationManagementTable/inlineLocation/inlineLocation.component";
import { LMCreateModalComponent } from "./components/Managment/locationManagement/locationModals/locationManagementCreateModal.component";
import { LocationFormInputComponent } from "./components/common/locationFromInput/locationFormInput.component";
import { LocationValidatorDirective } from "./common/directives/validators/locationValidator";
import { GreaterThatValidatorDirective } from "./common/directives/validators/greaterThanValidator";
import { LMNotificationModalComponent } from "./components/Managment/locationManagement/locationModals/locationNotificationModal.component";
import { CalculatorComponent } from "./components/calculator/calculator.component";
import { ShortLocationValidatorDirective } from "./common/directives/validators/shortLocationValidator";
import { ProductService } from "./services/productService";
import { OrderService } from "./services/orderService";
import { PageVisitService } from "./services/pageVisitService";
import { CalculatorTabComponent } from "./components/calculator/tabs/calculator-tab/calculatorTab.component";
import { CalcInfoRowComponent } from "./components/calculator/tabs/calcInfoRow/calcInfoRow.component";
import { CanadianCalculatorComponent } from "./components/calculator/tabs/calculatorResults/canadianCalculator.component";
import { UsaCalculatorComponent } from "./components/calculator/tabs/calculatorResults/usaCalculator.component";
import { AgentManagementComponent } from "./components/agent/agent-management.component";
import { AgentItemComponent } from "./components/agent/agent-item/agent-item.component";
import { NgxPaginationModule } from "ngx-pagination";
import { AgentModalComponent } from "./components/agent/modal/agent-modal.component";
import { AgentManagementResolver } from "./components/agent/agent-management.resolver";
import { GroupResolver } from "./components/agent/group.resolver";
import { GroupService } from "./services/groupService";
import { LocationItemComponent } from "./components/Managment/locationManagement/locationIitem/locationItem.component";
import { CustomerManagementResolver } from "./components/Managment/customerManagement/customerManagement.resolver";
import { CustomerManagementComponent } from "./components/Managment/customerManagement/customerManagement.component";
import { CustomerService } from "./services/customerService";
import { CustomerItemComponent } from "./components/Managment/customerManagement/customerItem/customerItem.component";
import { CustomerModalComponent } from "./components/Managment/customerManagement/modal/customerModal.component";
import { ProductItemComponent } from "./components/Managment/productManagement/productItem/productItem.component";
import { ProductManagementComponent } from "./components/Managment/productManagement/productManagement.component";
import { ProductManagementResolver } from "./components/Managment/productManagement/productManagement.resolver";
import { AccordionModule, CarouselModule } from "ngx-bootstrap";
import { CanadianCurrencyCodesResolver } from "./components/calculator/resolvers/canadian-currency-codes.resolver";
import { LocationCardComponent } from "./components/calculator/cards/location-card/location-card.component";
import { CustomerCardComponent } from "./components/calculator/cards/customer-card/customer-card.component";
import { ProductsCardComponent } from "./components/calculator/cards/products-card/products-card.component";
import { OrderDetailsCardComponent } from "./components/calculator/cards/order-details-card/order-details-card.component";
import { OrderDetailsAccordionComponent } from "./components/calculator/accordions/order-details-accordion/order-details-accordion.component";
import { ManagementSearchComponent } from "./components/Managment/search/managementSearch.component";
import { ManagementPaginationComponent } from "./components/Managment/pagination/managementPagination.component";
import { ProductModalComponent } from "./components/Managment/productManagement/modal/productModal.component";
import { OrderManagementComponent } from "./components/Managment/orderManagement/orderManagement.component";
import { OrderManagementResolver } from "./components/Managment/orderManagement/orderManagement.resolver";
import { OrderItemComponent } from "./components/Managment/orderManagement/orderItem/orderItem.component";
import { FillOrderTabComponent } from "./components/calculator/tabs/fill-order-tab/fill-order-tab.component";
import { CalculatorAccordion } from "./components/calculator/accordions/product-accordion/calculator-accordion.component";
import { CurrencyCardComponent } from "./components/calculator/cards/currency-card/currency-card.component";
import { OrderDetails } from "./components/Managment/orderManagement/orderDetails/orderDetails.component";
import { OrderDetailsResolver } from "./components/Managment/orderManagement/orderDetails/orderDetails.resolver";
import { ExtraDataService } from "./services/extraDataService";
import { ExtraDataResolver } from "./components/Managment/orderManagement/orderDetails/extraDataResolver";
import { CalculatorService } from "./services/calculator/calculatorService";
import { ValidatorsModule } from "ngx-validators";
import { LocationCalcValidatorDirective } from "./common/directives/validators/calcLocationValidator";
import { ManagementLocationValidatorDirective } from "./common/directives/validators/managementLocationValidator";
import { TotalAmountComponent } from "./components/reports/totalAmount/totalAmount.component";
import { DateRangeSelectorComponent } from "./components/reports/filterSelectors/dateSelector/dateRangeSelector.component";
import { NgxMyDatePickerModule } from "ngx-mydatepicker";
import { MyDateRangePickerModule } from "mydaterangepicker";
import { TotalFeeChartComponent } from "./components/reports/charts/totalFeeChart/totalFeeChart.component";
import { ReportService } from "./services/reportService";
import { TotalAmountReportResolver } from "./components/reports/totalAmount/totalAmountReport.resolver";
import { AgentSelectorComponent } from "./components/reports/filterSelectors/agentSelector/agentSelector.component";
import { TotalFeeReportComponent } from "./components/reports/totalFeeReport.component";
import { TotalQuantityReportComponent } from "./components/reports/totalQuantityReport.component";
import { TotalQuantityReportResolver } from "./components/reports/totalAmount/totalQuantityReport.resolver";
import { TotalAmountTableComponent } from "./components/reports/tables/totalAmountTable.component";
import { DebounceDirective } from "./components/common/debounce/debounceDirective";
import { OrderDataComponent } from "./components/Managment/orderManagement/orderData/orderData.component";
import { LeftTabComponent } from "./components/Managment/orderManagement/orderData/tabs/leftTab.component";
import { PreparingDocTabComponent } from "./components/Managment/orderManagement/orderData/tabs/preparingDocTab.component";
import { DocSelectorComponent } from "./components/Managment/orderManagement/orderData/tabs/docSelector.component";
import { NgUploaderModule } from "ngx-uploader";
import { NgUploaderService } from "ngx-uploader";
import { UploadService } from "./services/uploadService";
import { OrderContentService } from "./services/orderContentService";
import { OrderContentResolver } from "./components/Managment/orderManagement/orderData/orderContentResolver";
import { TooltipModule } from "ngx-tooltip";
import { PaymentRedirectComponent } from "./components/payment/paymentRedirect.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import {EmailService} from "./services/emailService";
import {PublicCalculatorComponent} from "./components/calculator/public/public-calculator.component";
import { AllUserResolver } from "./components/reports/totalAmount/allUser.resolver";
import { ElementAutoSize } from "./common/directives/elementAutoSize.directive";
import { LogService } from "./services/logService";
import {CountryService} from "./services/CountryService";
import { ProductValidatorValidatorDirective } from "./common/directives/validators/productNameValidator";
import { WizardModule } from "ngx-wizard";
import { PublicCalculatorV2Component } from "./components/calculator/public/mobile/public-calculator-v2.component";
import { DefaultTariffResolver } from "./components/calculator/resolvers/default-tarff.resolver";
import { ResultTabV2Component } from "./components/calculator/public/mobile/result-tab/result-tab-v2.component";
import { CanadianResultsV2Component } from "./components/calculator/public/mobile/result-tab/canadian/canadian-results-v2.component";
import { USAResultsV2Component } from "./components/calculator/public/mobile/result-tab/usa/usa-results-v2.component";
import { PublicWizardV2Component } from "./components/calculator/public/mobile/wizard/public-wizard-v2.component";
import { EmailTabsV2Component } from "./components/calculator/public/mobile/email-tab/email-tab-v2.component";
import { LocationToTabsV2Component } from "./components/calculator/public/mobile/locationTo-tab/locationTo-tab-v2.component";
import { CanadianQuestionsTabV2Component } from "./components/calculator/public/mobile/canadian-questions-tab/canadian-questions-tab-v2.component";
import { ManufacturerTabV2Component } from "./components/calculator/public/mobile/manufacturer-tab/manufacturer-tab-v2.component";
import { PriceTabV2Component } from "./components/calculator/public/mobile/price-tab/price-tab-v2.component";
import { FormTextareaComponent } from "./components/common/formTextarea/formTextarea.component";
import { OrderExportComponent } from "./components/export/order-export.component";
import { OrderTableViewComponent } from "./components/Managment/orderManagement/tableView/order-table-view.component";
import { OrderColumnModalComponent } from "./components/Managment/orderManagement/order-column-modal/order-column-modal.component";
import { UserViewService } from "./services/userViewService";
import { NgxDnDModule } from "@swimlane/ngx-dnd";
import { UserViewResolver } from "./components/userView/user-view.resolver";
import { UserViewOrderResolver } from "./components/userView/user-view-order.resolver";
import { OrderODataService } from "./services/orderOData.service";
import { ScrollHandlerDirective } from "./common/directives/scrollHandler.directive";
import { ClearanceFeeCardComponent } from "./components/calculator/cards/currency-card/clearance-fee-card.component";
import { ClearanceOptionComponent } from "./components/calculator/cards/currency-card/clearance-option/clearance-option.component";
import { ClickOutsideDirective } from "./common/directives/click-outside.directive";
import { AaFeeChangeModalComponent } from "./components/calculator/modals/aafee-change-modal.component";
import { AskQuestionTabComponent } from "./components/calculator/public/mobile/ask-question-tab/ask-question-tab.component";
import { AdvancedDocSelectorComponent } from "./components/Managment/orderManagement/orderData/tabs/advancedDocSelector.component";
import { OrderExportModalComponent } from "./components/Managment/orderManagement/order-export-modal/order-export-modal.component";
import { DatePickerComponent } from "./components/common/datepicker/datepicker.component";
import { AmazonCredentialsComponent } from "./components/amazon/store-credentials/amazon-credentials.component";
import { AmazonService } from "./services/amazon.service";
import { AmazonComponent } from "./components/amazon/amazon.component";
import { AmazonGeneralInfoComponent } from "./components/amazon/info-steps/amazon-general-info.component";
import { AmazonCongratulationComponent } from "./components/amazon/congratulation/amazon-congratulation.component";
import { CarouselComponent } from "./components/amazon/carousel/carousel.component";
import { Document3461Component } from "./components/export-documents/cbp-3461/document-3461.component";
import { HeaderInfo3461Component } from "./components/export-documents/cbp-3461/document-blocks/header-info-3461.component";
import { HeaderParties3461Component } from "./components/export-documents/cbp-3461/document-blocks/header-parties-3461.component";
import { CertificationInfo3461Component } from "./components/export-documents/cbp-3461/document-blocks/certification-info-3461.component";
import { LineInformationComponent3461 } from "./components/export-documents/cbp-3461/document-blocks/line-information.component-3461";
import { BillOfLanding3461Component } from "./components/export-documents/cbp-3461/document-blocks/bill-of-landing-3461.component";
import { DocumentService } from "./services/documentService";
import { OrderDataResolver } from "./components/Managment/orderManagement/orderData/orderData.resolver";
import { Document7501Component } from "./components/export-documents/cbp-7501/document-7501.component";
import { FirstBlock7501Component } from "./components/export-documents/cbp-7501/document-blocks/first-block-7501.component";
import { TableBlock7501Component } from "./components/export-documents/cbp-7501/document-blocks/table-block-7501.component";
import { ThirdBlock7501Component } from "./components/export-documents/cbp-7501/document-blocks/third-block-7501.component";
import { OrderDataCBP7501Resolver } from "./components/Managment/orderManagement/orderData/orderDataCBP7501.resolver";
import { DeclarationBlock7501Component } from "./components/export-documents/cbp-7501/document-blocks/declaration-block-7501.component";
import { ReValidateLinkedControls } from "./common/directives/validators/documentValidators/revalidateLinkedControls";
import { FormInputErrorsComponent } from "./components/export-documents/form-input-errors.component";
import { GoogleTagService } from "./services/google-tag.service";
import { AmazonInfoComponent } from "./components/amazon/amazon-info/amazon-info.component";
import { SellerItemComponent } from "./components/Managment/amazon-management/seller/seller-item.component";
import { AmazonSellerManagementComponent } from "./components/Managment/amazon-management/amazon-seller-management.component";
import { AmazonSellerManagementResolver } from "./components/Managment/amazon-management/amazon-seller-management.resolver";
import { SellerModalComponent } from "./components/Managment/amazon-management/seller/seller-modal.component";
import { AmazonStoreManagement } from "./components/Managment/amazon-management/store/amazon-store-management";
import { AmazonStoreResolver } from "./components/Managment/amazon-management/store/amazon-store.resolver";
import { AmazonCurrentSellerResolver } from "./components/amazon/amazon-info/amazon-currentSelleer.resolver";
import { AmazonStoreProductsComponent } from "./components/amazon/products/amazon-store-products.component";
import { AmazonProductCardComponent } from "./components/amazon/product-card/amazon-product-card.component";
import { InlineInputComponent } from "./components/common/inline-input/inline-input.component";
import { AmazonProductResolver } from "./components/Managment/amazon-management/store/amazon-product.resolver";
import { AmazonSellerFormComponent } from "./components/amazon/seller-form/amazon-seller-form.component";
import { AmazonProductExportComponent } from "./components/Managment/amazon-management/store/amazon-product-export.component";
import { AmazonDashboardComponent } from "./components/amazon/amazon-dashboard/amazon-dashboard.component";
import { AmazonGuard } from "./common/guards/amazonGuard";
import { AmazonSignFormComponent } from "./components/amazon/sign/amazon-sign-form-modal.component";
import { AmazonInstructionsComponent } from "./components/amazon/instructions/amazon-instructions.component";
import { TaxService } from "./services/calculator/tax.service";
import { TextMaskModule } from "angular2-text-mask";
import { ShipmentFromTabComponent } from "./components/calculator/public/mobile/shipment-from-tab/shipment-from-tab.component";
import { HowCarryingComponent } from "./components/calculator/public/mobile/carrying/how-carrying.component";
import { OrderPaymentComponent } from "./components/calculator/public/mobile/order-payment/order-payment.component";
import {PaymentService} from "./services/paymentService";
import {NgxCurrencyModule} from "ngx-currency";
import { ApiDocumentationComponent } from "./components/api-documentation/api-documentation.component";
import {PublicCalculatorV2TitleComponent} from "./components/common/publick-calculator-v2-title/publick-calculator-v2-title.component";
import { CustomersImportComponent } from "./components/Managment/customers-import/customersImport.component";
import {ParsStatusWidgetComponent} from "./components/pars-status-widget/pars-status-widget.component";
import {ParsStatusRefreshComponent} from "./components/pars-status-widget/pars-status-refresh.component";
import {RNSService} from "./services/RNS.service";
import { PublisherService } from "./services/publisher.service";
import { ZonosComponent } from "./components/zonos/zonos.component";
import { ZonosService } from "./services/zonos.service";

export function createConfigService(config: ConfigService, handler: any) {
    return () => config.load();
}

export function createCountryDataService(countryService: CountryService, handler: any) {
    return () => countryService.load();
}

export class CustomToastOption extends ToastOptions {
    newestOnTop = false;
    showCloseButton = true;
    positionClass = "toast-top-full-width";
    enableHTML = true;
    maxShown = 5;
}

export class customErrorHandler extends ErrorHandler {
    private _storageManager: StorageManager;
    private _logService: LogService;

    private get storageManager(): StorageManager {
        if (this._storageManager)
            return this._storageManager;

        let store = this.injector.get(StorageManager);

        if (store)
            this._storageManager = store;

        return this._storageManager;
    }

    private get logService(): LogService {
        if (this._logService)
            return this._logService;

        let log = this.injector.get(LogService);

        if (log)
            this._logService = log;

        return this._logService;
    }

    constructor(private injector: Injector) {
        super();
    }

    async handleError(error: any): Promise<void> {
        let store = this.storageManager;

        let currentUser = await store.getCurrentUser();

        let extraData = [new Tuple<string, any>("Stack", error.stack),
            new Tuple<string, any>("Url", window.location.href),
            new Tuple<string, any>("UserAgent", navigator.userAgent),
            new Tuple<string, any>("ScreenWidth", screen.width),
            new Tuple<string, any>("ScreenHeight", screen.height)];

        if (currentUser) {
            extraData.push(new Tuple<string, any>("UserId", currentUser.Id),
                    new Tuple<string, any>("UserEmail", currentUser.Email))
        }

        let request = new LogRequest({
            LogLevel: LogLevel.Error,
            Message: error.message,
            ExtraData: extraData
        });

        this.logService.save(request).catch();

        super.handleError(error);
    }
}

class LogRequest {
    public Message: string;

    public ExtraData: Array<Tuple<string, any>>;

    public LogLevel: LogLevel;

    public constructor(init?: Partial<LogRequest>) {
        Object.assign(this, init);
    }
}

enum LogLevel{
    Trace,
    Debug,
    Info,
    Warn,
    Error,
    Fatal,
    Off
}

class Tuple<T1, T2> {

    constructor(public Item1: T1, public Item2: T2) {
    }

}

export const customCurrencyMaskConfig = {
    align: "left",
    allowNegative: true,
    allowZero: true,
    decimal: ".",
    precision: 2,
    prefix: "$ ",
    suffix: "",
    thousands: ",",
    nullable: true
};

@NgModule({
    imports: [BrowserModule, FormsModule, ReactiveFormsModule, RouterModule.forRoot(appRoutes), HttpModule, BrowserAnimationsModule, ToastModule.forRoot(), ModalModule.forRoot(), AccordionModule.forRoot(),
        CollapseModule.forRoot(), BsDropdownModule.forRoot(), NgxDatatableModule, ChartsModule, GooglePlaceModule, NgxPaginationModule, ValidatorsModule, TextMaskModule,
        NgxMyDatePickerModule.forRoot(), MyDateRangePickerModule, NgUploaderModule, TooltipModule, WizardModule, NgxDnDModule, CarouselModule.forRoot(),
        NgxCurrencyModule.forRoot(customCurrencyMaskConfig)],
    declarations: [AppComponent, PaymentRedirectComponent, LayoutComponent, AuthLayoutComponent, LoginComponent, RegisterComponent, ForgotPasswordComponent, ResetPasswordComponent,
        HomeComponent, ErrorsSummaryComponent, FormInputComponent, CheckboxComponent,
        SideBarComponent, SideMenuComponent, NavbarComponent, FormSelectComponent, RadioComponent, FirstKeyPipe, CheckboxRequiredValidatorDirective,
        EqualValidatorDirective, OnFocusDirective, TrimValueAccessor, NgTranscludeDirective, RipplesDirective, GoogleLoginComponent, DashboardComponent, CurrencyDashBoardComponent,
        CurrencyChartComponent, CurrencyTableComponent, LocationManagementComponent, LocationManagementSearchComponent, LocationManagementTableComponent, InlineSelectComponent,
        InlineLocationComponent, LMCreateModalComponent, LocationFormInputComponent, LocationValidatorDirective, GreaterThatValidatorDirective, LMNotificationModalComponent,
        CalculatorComponent, ShortLocationValidatorDirective, CalculatorTabComponent, CalcInfoRowComponent,
        CanadianCalculatorComponent, UsaCalculatorComponent, PublicCalculatorComponent, FormTextareaComponent,
        AgentManagementComponent, AgentItemComponent, AgentModalComponent, CalculatorAccordion, LocationItemComponent, ClickOutsideDirective, CarouselComponent,
        /*cards start*/
        LocationCardComponent, CustomerCardComponent, ProductsCardComponent, OrderDetailsCardComponent, CurrencyCardComponent, ClearanceFeeCardComponent,ClearanceOptionComponent,
        /*cards end*/
        OrderDetailsAccordionComponent, FillOrderTabComponent, AaFeeChangeModalComponent,
        CustomerManagementComponent, CustomerItemComponent, CustomerModalComponent, CustomersImportComponent,
        ProductItemComponent, ProductManagementComponent, ManagementSearchComponent, ManagementPaginationComponent, ProductModalComponent,
        OrderManagementComponent, OrderItemComponent, OrderDetails, LocationCalcValidatorDirective,
        /** documents validators start**/
        ReValidateLinkedControls,
        /** documents validators end**/
        /**reports start **/
        TotalAmountComponent, DateRangeSelectorComponent, TotalFeeChartComponent, AgentSelectorComponent, TotalFeeReportComponent, TotalQuantityReportComponent,
        TotalAmountTableComponent,
        /**reports end **/
        /** Amazon start*/
        AmazonCredentialsComponent, AmazonComponent, AmazonGeneralInfoComponent,AmazonCongratulationComponent, AmazonInfoComponent,
        SellerItemComponent, AmazonSellerManagementComponent, SellerItemComponent, SellerModalComponent, AmazonStoreManagement, AmazonStoreProductsComponent,
        AmazonProductCardComponent, AmazonSellerFormComponent, AmazonProductExportComponent, AmazonDashboardComponent, AmazonSignFormComponent, AmazonInstructionsComponent,
        /** Amazon end*/

        OrderExportModalComponent, DatePickerComponent,
        DebounceDirective, ScrollHandlerDirective,
        LeftTabComponent, PreparingDocTabComponent, DocSelectorComponent,
        OrderDataComponent, ManagementLocationValidatorDirective, ElementAutoSize, AdvancedDocSelectorComponent,
        ProductValidatorValidatorDirective, PublicCalculatorV2Component, ResultTabV2Component, CanadianResultsV2Component, USAResultsV2Component,
        PublicWizardV2Component, EmailTabsV2Component, LocationToTabsV2Component, CanadianQuestionsTabV2Component, ManufacturerTabV2Component, PriceTabV2Component,
        AskQuestionTabComponent, OrderExportComponent, OrderTableViewComponent, OrderColumnModalComponent, ShipmentFromTabComponent,
        HowCarryingComponent,
        PublicCalculatorV2TitleComponent,

        /**Documents start**/
        Document3461Component, HeaderInfo3461Component, HeaderParties3461Component, CertificationInfo3461Component, LineInformationComponent3461, BillOfLanding3461Component,
        Document7501Component, FirstBlock7501Component, TableBlock7501Component, ThirdBlock7501Component , DeclarationBlock7501Component, FormInputErrorsComponent,
        /**Documents end**/
        /**Common start*/
        InlineInputComponent,
        /**Common end*/
        OrderPaymentComponent,
        ApiDocumentationComponent,
        ParsStatusWidgetComponent,
        ParsStatusRefreshComponent,
        ZonosComponent
    ],
    bootstrap: [AppComponent],
    providers: [ConfigService, CountryService, CookieService, UserService, AppService, SipService, StorageManager, AuthGuard, AppGuard, AmazonGuard,
        CurrencyService, CurrencyResolver, GoogleService, LocationManagementResolver, LocationService, EmailService, LogService,
        ProductService, OrderService, PageVisitService, AgentManagementResolver, GroupResolver, GroupService, CanadianCurrencyCodesResolver,
        CustomerManagementResolver, CustomerService, ProductManagementResolver, OrderManagementResolver, OrderDetailsResolver, CalculatorService, ExtraDataResolver, ExtraDataService,
        ReportService, TotalAmountReportResolver, TotalQuantityReportResolver, UploadService, OrderContentService, OrderContentResolver, AllUserResolver, DefaultTariffResolver,
        UserViewService, UserViewResolver,UserViewOrderResolver, OrderODataService, AmazonService, DocumentService, OrderDataResolver, OrderDataCBP7501Resolver, GoogleTagService,
        AmazonSellerManagementResolver,AmazonStoreResolver, AmazonCurrentSellerResolver, AmazonProductResolver,
        TaxService,
        PaymentService,
        RNSService,
        PublisherService,
        ZonosService,
        {
            provide: APP_INITIALIZER,
            useFactory: createConfigService,
            deps: [ConfigService, ErrorHandler],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: createCountryDataService,
            deps: [CountryService, ErrorHandler],
            multi: true
        },
        {
            provide: ToastOptions,
            useClass: CustomToastOption
        },
        {
            provide: ErrorHandler,
            useClass: customErrorHandler,
            deps: [Injector]
        }
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./app/app.module.ts